import { IonIcon } from '@ionic/react'
import { useStore, useStoreMap } from 'effector-react'
import { arrowForwardOutline } from 'ionicons/icons'
import { useMemo } from 'react'
import { driverModel } from '~/entities/Driver'
import { Button } from '~/shared/ui/Buttons'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { $mainTaxiparkCmsLink } from './model'
import { Title, SubTitle, Wrapper, MainTaxiparkCmsLink } from './styled'

export function MainTaxipark() {
  const driverPending = useStore(driverModel.getDriverFx.pending)

  const taxiparksCount = useStoreMap(
    driverModel.$driver,
    (driver) => driver?.getTaxiparks()?.length || 0,
  )
  const mainTaxiparkCmsLink = useStoreMap($mainTaxiparkCmsLink, (cms) =>
    cms?.getAttributes(),
  )

  const mainTaxiparkName = useStoreMap(driverModel.$driver, (driver) =>
    (driver?.getTaxiparks() || [])
      .find((taxipark) => taxipark.getApiId() === driver?.getMainTaxiparkId())
      ?.getName(),
  )

  const isTaxiparkChange = mainTaxiparkName && taxiparksCount > 1

  const taxiparkTitle = useMemo(() => {
    if (driverPending) {
      return (
        <Skeleton
          animated
          $height={20}
          style={{ marginBottom: '0', marginTop: '4px' }}
        />
      )
    }

    return mainTaxiparkName
  }, [driverPending, mainTaxiparkName])

  return (
    <Wrapper>
      <SubTitle>Активный таксопарк</SubTitle>
      {mainTaxiparkCmsLink && (
        <MainTaxiparkCmsLink href={mainTaxiparkCmsLink.content} target='_blank'>
          {mainTaxiparkCmsLink.previewContent}
          <IonIcon
            icon={arrowForwardOutline}
            style={{
              fontSize: '16px',
            }}
          />
        </MainTaxiparkCmsLink>
      )}
      <Title data-testid='active-taxipark'>{taxiparkTitle}</Title>

      {isTaxiparkChange && (
        <Button
          to='/taxiparks'
          variant='lightSteelBlueBorder'
          style={{ marginTop: '12px' }}
          contentProps={{ style: { padding: '6px 16px' } }}
          fullWidth
        >
          Изменить
        </Button>
      )}
    </Wrapper>
  )
}
